import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../../../components';
import { showConfirmDialog } from '../../../../../components/modals';
import { onError, onSuccess } from '../../../../../utils/errors';
import Sellable from '../../../store/sellable/Sellable';

export default observer(function ArchiveSellableButton({
  sellable,
  sellableName,
}: {
  sellable: Sellable;
  sellableName: string;
}) {
  const navigate = useNavigate();

  if (sellable.isNew || sellable.archived) {
    return null;
  }

  return (
    <Button
      icon="archive"
      onClick={() => archiveSellable(sellable, navigate, sellableName)}
      type="secondary"
    >
      Archive
    </Button>
  );
});

async function archiveSellable(
  sellable: Sellable,
  navigate: (route: string) => void,
  sellableName: string,
) {
  const sellableNameLow = sellableName.toLowerCase();

  const productName = await showConfirmDialog({
    title: 'Are you absolutely sure?',
    content: (
      <>
        It will make the <b>{sellable.displayName}</b> {sellableNameLow}{' '}
        unavailable for customers.
      </>
    ),
    confirmButton: {
      title: `I understand the consequences, archive this ${sellableNameLow}`,
      color: 'secondary',
      disabled: true,
    },
    textField: {
      label: (
        <>
          Please type <b>{sellable.displayName}</b> to confirm.
        </>
      ),
    },
    onType(text, opts) {
      if (opts.confirmButton) {
        // eslint-disable-next-line no-param-reassign
        opts.confirmButton.disabled =
          text.trim().toLowerCase() !== sellable.displayName.toLowerCase();
      }
    },
  });

  if (productName.trim().toLowerCase() === sellable.displayName.toLowerCase()) {
    try {
      await sellable.archive();
      navigate(sellableNameLow === 'bundle' ? '/bundles' : '/products');
      onSuccess(`${sellable.name} ${sellableNameLow} successfully archived`);
    } catch (e) {
      onError(e, `Cannot archive the ${sellableNameLow}`);
    }
  }

  return null;
}
